import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'

export const CONTACTS_SUB_PATH_TABS = {
  all: 'all',
  meetings: 'meetings',
  emails: 'emails',
  notes: 'notes',
}

const TAB_PATH_BY_NAME = {
  contacts: '/app/contacts',
}

const SUB_PATHS_BY_TAB_NAME = {
  contacts: CONTACTS_SUB_PATH_TABS
}

export const useActivePaths = () => {
  const location = useLocation()

  // Returns an array of active paths for a given tab name
  const getTabActivePaths = useCallback((tabName) => {
    const tabPath = TAB_PATH_BY_NAME[tabName]
    if (!tabPath) return []

    const match = location.pathname.match(`${tabPath}/([^/]+)`)
    const id = match?.[1]

    if (id && id !== 'me') {
      let activePaths = [`${tabPath}/${id}`]
      const subPaths = SUB_PATHS_BY_TAB_NAME[tabName] || []
      activePaths = activePaths.concat(
        Object.values(subPaths).map((subPath) => `${tabPath}/${id}/${subPath}`)
      )
      return activePaths
    }
    return []
  }, [location.pathname])

  return {
    getTabActivePaths
  }
}
